import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setColumns } from './store/actions/session';
import { getCurrentColumns } from './store/selectors/session';
import { getDefaultColumns } from './store/selectors/static';

import ColumnSelector from 'components/table_header/column_selector';

export class RequirementsColumnSelector extends React.Component {

  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    defaultColumns: PropTypes.array.isRequired,
    informationMappings: PropTypes.object.isRequired,
    onCancelColumns: PropTypes.func.isRequired,
    onSetColumns: PropTypes.func.isRequired
  };

  handleSetColumns = (columns) => {
    const { defaultColumns, onSetColumns } = this.props;

    const distinctValues = columns.filter(c => defaultColumns.indexOf(c) < 0);
    onSetColumns(distinctValues);
  }

  render() {
    return (
      <ColumnSelector
        {...this.props}
        onSetColumns={this.handleSetColumns}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: getCurrentColumns(state),
  defaultColumns: getDefaultColumns(state)
});

const mapDispatchToProps = {
  onSetColumns: setColumns
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsColumnSelector);